import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Alert
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { InputBase } from '@mui/material';
import notaFiscalService from '../../../services/notaFiscalService';

const ModalEnviarNota = ({ open, onClose, solicitacao, onNotaEnviada }) => {
  const [arquivo, setArquivo] = useState(null);
  const [numeroNota, setNumeroNota] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);
  const [enviando, setEnviando] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      setArquivo(file);
      setErro('');
    } else {
      setErro('Por favor, selecione um arquivo PDF válido.');
    }
  };

  const handleSubmit = async () => {
    if (!arquivo) {
      setErro('Por favor, selecione um arquivo PDF.');
      return;
    }

    if (!numeroNota.trim()) {
      setErro('Por favor, informe o número da nota fiscal.');
      return;
    }

    // Verificar se temos o ID da compra
    if (!solicitacao?.COM_ID) {
      setErro('ID da compra não encontrado.');
      return;
    }

    setEnviando(true);
    setErro('');

    try {
      const response = await notaFiscalService.enviarNotaFiscal(
        solicitacao.COM_ID, // Usar COM_ID em vez de id
        arquivo,
        numeroNota
      );

      if (response.status) {
        setSucesso(true);
        setTimeout(() => {
          onNotaEnviada(solicitacao.COM_ID);
          onClose();
          setSucesso(false);
          setArquivo(null);
          setNumeroNota('');
        }, 2000);
      } else {
        setErro(response.message || 'Erro ao enviar nota fiscal.');
      }
    } catch (error) {
     // console.error('Erro ao enviar nota fiscal:', error);
      const errorMessage = error.response?.data?.message || 'Erro ao enviar nota fiscal. Tente novamente.';
      setErro(errorMessage);
    } finally {
      setEnviando(false);
    }
  };

  // Calcular valor total da compra
  const calcularValorTotal = () => {
    if (!solicitacao?.itens || solicitacao.itens.length === 0) return 0;
    return solicitacao.itens.reduce((total, item) => {
      const valor = Number(item.item_compra?.ITC_VALOR_REVISADO || item.item_compra?.ITC_VALOR_ORIGINAL || 0);
      const quantidade = Number(item.IT_QUANTIDADE || 0);
      return total + (valor * quantidade);
    }, 0);
  };

  const valorTotal = calcularValorTotal();
  const prefeituraNome = solicitacao?.cotacao?.solicitacao?.prefeitura?.PRE_NOME || 'Prefeitura não informada';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">
            Enviar Nota Fiscal - Solicitação {solicitacao?.COM_SOL_ID}
          </Typography>
          <Button onClick={onClose} color="inherit">
            <CloseIcon />
          </Button>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Box mb={2}>
          <Typography variant="subtitle1" gutterBottom>
            <strong>Prefeitura:</strong> {prefeituraNome}
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            <strong>Valor Total:</strong> {valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
          </Typography>
        </Box>

        {erro && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {erro}
          </Alert>
        )}

        {sucesso && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Nota fiscal enviada com sucesso!
          </Alert>
        )}

        <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            variant="body2"
            sx={{
              color: 'text.primary',
              fontWeight: 400,
              minWidth: '50px',
              whiteSpace: 'nowrap',
              fontSize: '1rem'
            }}
          >
            Nº da Nota Fiscal:
          </Typography>
          <InputBase
            value={numeroNota}
            onChange={(e) => setNumeroNota(e.target.value)}
            placeholder="Digite o número"
            sx={{
              width: '180px',
              height: '56px',
              padding: '6px 2px',
              borderRadius: '1px',
              fontSize: '1rem',
              backgroundColor: '#fff',
              color: '#000',
              '&::placeholder': {
                color: '#999',
              }
            }}
          />

        </Box>

        <Button
          variant="outlined"
          component="label"
          startIcon={<CloudUploadIcon />}
          fullWidth
          sx={{ mt: 2 }}
        >
          Upload do PDF
          <input
            type="file"
            hidden
            accept=".pdf"
            onChange={handleFileChange}
          />
        </Button>
        {arquivo && (
          <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
            Arquivo selecionado: {arquivo.name}
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={enviando}>
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={enviando || sucesso}
        >
          {enviando ? 'Enviando...' : 'Enviar Nota'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalEnviarNota; 